import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppointmentState } from '../../model/appointment-book.models';
import { Session } from '../../model/resource.model';
import ScrollView from 'devextreme/ui/scroll_view';
import { LookupItem } from '../../model/AS365Defaults.model';

@Component({
  selector: 'app-appointment-session',
  templateUrl: './appointment-session.component.html',
  styleUrls: ['./appointment-session.component.css'],
})
export class AppointmentSessionComponent implements OnChanges {
  @Input() sessions: Session[] = [];
  @Input() sessionCategories: LookupItem[] = [];
  @Input() sessionTiles: SessionTile[] = [];
  @Input() aptState: AppointmentState = AppointmentState.New;
  @Output() onSessionSelected: EventEmitter<Session> = new EventEmitter<Session>();
  _sessionTiles: SessionTile[] = [];
  sessionSearchActive: boolean = false;
  sessionSearchInput: string = '';

  private selectedSessionId = -1;
  @Input() public set SelectedSession(Id: number) {
    this.selectSession(Id);
  }
  public get SelectedSession() {
    return this.selectedSessionId;
  }

  private selectedSessionCategoryId = -1;
  @Input() public set SelectedSessionCategory(Id: number) {
    this.selectSessionCategory(Id);
  }
  public get SelectedSessionCategory() {
    return this.selectedSessionCategoryId;
  }

  constructor() {
    this.selectSession(this.SelectedSession);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.sessionTiles?.currentValue) {
      this._sessionTiles = changes.sessionTiles.currentValue;
    }
  }

  onContentReady(e) {
    let instance = ScrollView.getInstance(e.element);
    instance.option('useNative', false);
  }

  selectSession(Id: number, raiseEvent?: boolean) {
    if (this.selectedSessionId !== Id) {
      const item = this.sessions.find((i) => i.SessionId === Id);
      if (item) {
        this.sessionTiles.filter((i) => !i.IsCategory).forEach((i) => (i.Selected = !i.IsCategory && i.Id === Id));
        this.selectedSessionId = Id;
        if (raiseEvent) {
          this.onSessionSelected.emit(item);
        }
      } else {
        this.selectedSessionId = Id;
        this.sessionTiles.filter((i) => !i.IsCategory).forEach((i) => (i.Selected = false));
      }
    }
  }

  selectSessionCategory(Id: number) {
    const item = this.sessionCategories.find((i) => i.Value === Id);
    if (item && this.selectedSessionCategoryId !== Id) {
      this.sessionTiles.filter((i) => i.IsCategory).forEach((i) => (i.Selected = !!i.IsCategory && i.Id === Id));
      this.selectedSessionCategoryId = Id;
    } else {
      this.selectedSessionCategoryId = -1;
      this.sessionTiles.filter((i) => i.IsCategory).forEach((i) => (i.Selected = false));
    }
    this.applyFilters();
  }

  applyFilters() {
    this._sessionTiles = this.sessionTiles.filter(
      (i) =>
        i.IsCategory ||
        ((this.selectedSessionCategoryId === -1 || i.CategoryIds?.includes(this.selectedSessionCategoryId)) &&
          (!this.sessionSearchActive || i.Description.toLowerCase().includes(this.sessionSearchInput.toLowerCase())))
    );
  }

  itemClicked(e: SessionTile) {
    if (e.IsCategory) {
      this.selectSessionCategory(e.Id);
    } else {
      // Do not allow changes once apt has been booked
      if (this.aptState >= AppointmentState.Booked) {
        return;
      }
      this.selectSession(e.Id, true);
    }
  }

  onSessionSearchInput(e: any) {
    this.sessionSearchInput = (<string>e.event.target.value)?.toLowerCase();
    if (this.sessionSearchInput && this.sessionSearchInput.length >= 3) {
      this.sessionSearchActive = true;
    } else {
      this.sessionSearchActive = false;
    }
    this.applyFilters();
  }
}

export class SessionTile {
  CategoryIds: number[];
  Id: number;
  IsCategory: boolean;
  Description: string;
  Selected: boolean;
  RetailPrice: number | null;
}
